// extracted by mini-css-extract-plugin
module.exports = {"root":"latest-notebook-data_root__5YR4X"};